import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Coins, LogIn, Crown, Star, User as UserIcon, Home } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { startGoogleLogin, logout } from "../game/authService";

// Shared top nav used on the Arcade home + Coming Soon pages. Compact
// design so it doesn't dominate the screen but always exposes login,
// coin balance, and VIP tier. Inside ZC3D itself, the existing Menu UI
// already shows these — we don't duplicate there.
export default function ArcadeNav({ showHomeLink = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const onHome = location.pathname === "/" || location.pathname === "/arcade";

  return (
    <header className="arcade-nav" data-testid="arcade-nav">
      <div className="arcade-nav-inner">
        <Link to="/" className="arcade-brand" data-testid="arcade-brand-link">
          <span className="arcade-brand-dot" aria-hidden="true" />
          <span className="arcade-brand-text">
            <b>Zombie</b> Arcade
          </span>
        </Link>

        <nav className="arcade-nav-actions">
          {showHomeLink && !onHome && (
            <Link
              to="/"
              className="arcade-nav-btn"
              data-testid="arcade-nav-home"
              title="Back to Arcade"
            >
              <Home size={14} /> Arcade
            </Link>
          )}
          {!loading && user && (
            <>
              <div className="arcade-nav-coins" data-testid="arcade-nav-coins" title="Your coin balance">
                <Coins size={14} /> {(user.coins || 0).toLocaleString()}
              </div>
              {user.founder && (
                <span className="arcade-nav-tier founder" data-testid="arcade-nav-tier-founder" title="Founder">
                  <Crown size={12} /> Founder
                </span>
              )}
              {!user.founder && user.is_vip && (
                <span className="arcade-nav-tier vip" data-testid="arcade-nav-tier-vip" title="VIP">
                  <Star size={12} /> VIP
                </span>
              )}
              <div className="arcade-nav-user" data-testid="arcade-nav-user">
                {user.picture ? (
                  <img src={user.picture} alt={user.name || "Player"} className="arcade-nav-avatar" />
                ) : (
                  <UserIcon size={16} />
                )}
                <span className="arcade-nav-name">{user.name || user.email || "Player"}</span>
              </div>
              <button
                type="button"
                className="arcade-nav-btn ghost"
                onClick={logout}
                data-testid="arcade-nav-logout"
                title="Sign out"
              >
                Sign out
              </button>
            </>
          )}
          {!loading && !user && (
            <button
              type="button"
              className="arcade-nav-btn primary"
              onClick={startGoogleLogin}
              data-testid="arcade-nav-login"
            >
              <LogIn size={14} /> Sign in with Google
            </button>
          )}
        </nav>
      </div>
    </header>
  );
}
